import React from 'react';
import { Link } from 'react-router-dom';
import { FaFlagUsa, FaFlag } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

import logo from '../assets/images/logo.png';
import '../assets/styles/Header.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const Header = () => {
  const { language, setLanguage } = useLanguage();

  // Fonction pour faire défiler vers les sections
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Contenu du header selon la langue
  const headerContent = {
    fr: {
      home: "Accueil",
      about: "À Propos",
      services: "Services",
      podcasts: "Podcasts",
      phototheques: "Photothèque",
      videotheques: "Vidéothèque",
      contact: "Contact"
    },
    en: {
      home: "Home",
      about: "About Us",
      services: "Services",
      podcasts: "Podcasts",
      phototheques: "Photo Gallery",
      videotheques: "Video Gallery",
      contact: "Contact"
    }
  };

  const currentHeaderContent = headerContent[language];

  return (
    <nav className="navbar navbar-expand-lg navbar-white bg-white">
      <div className="container">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img
            src={logo}
            alt="K'MDEU FARMS Logo"
            className="logo-img"
          />
        </Link>

        {/* Sélecteur de langue */}
        <div className="language-selector me-3">
          <button
            className={`btn btn-sm ${language === 'fr' ? 'btn-success' : 'btn-outline-success'}`}
            onClick={() => setLanguage('fr')}
            title="Français"
          >
            <FaFlag className="me-1" /> FR
          </button>
          <button
            className={`btn btn-sm ${language === 'en' ? 'btn-success' : 'btn-outline-success'} ms-1`}
            onClick={() => setLanguage('en')}
            title="English"
          >
            <FaFlagUsa className="me-1" /> EN
          </button>
        </div>

        {/* Bouton pour le menu responsive */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu de navigation */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                {currentHeaderContent.home}
              </Link>
            </li>

            <li className="nav-item">
              <a 
                className="nav-link" 
                href="#about-section"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about-section');
                }}
              >
                {currentHeaderContent.about}
              </a>
            </li>
            
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="#products-section"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('products-section');
                }}
              >
                {currentHeaderContent.services}
              </a>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/podcasts">
                {currentHeaderContent.podcasts}
              </Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/phototheques">
                {currentHeaderContent.phototheques}
              </Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/videotheques">
                {currentHeaderContent.videotheques}
              </Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                {currentHeaderContent.contact}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;